import { render, staticRenderFns } from "./DisplayCurrency.vue?vue&type=template&id=556a442c&scoped=true"
import script from "./DisplayCurrency.vue?vue&type=script&lang=js"
export * from "./DisplayCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a442c",
  null
  
)

export default component.exports